import { BaseService } from '../base';
class ConfigurationsService extends BaseService {
    constructor() {
        super('/settings/configurations');
    }
    async getByIdAndType(type, name) {
        const response = await this.httpClient.get(`${this.basePath}/${type}/${name}`);
        return response.data;
    }
    async deleteByIdAndType(type, name) {
        const response = await this.httpClient.delete(`${this.basePath}/${type}/${name}`);
        return response.data;
    }
}
export default ConfigurationsService;
